/**
 * Reports an OAuth/SSO popup's result back to the window that opened it.
 *
 * `window.opener` stays a truthy `WindowProxy` even after Cross-Origin-Opener-Policy
 * severs the browsing-context link, so a `window.opener &&` check alone does not guard
 * against it — reading any named property off it (including `HandlePopupResult`) throws
 * `SecurityError: ... Blocked a frame ... from accessing a cross-origin frame.` once
 * severed. Guard the property access itself, not just the reference.
 *
 * Usage: `safeNotifyPopupOpener(queryJSON, null)` on success, or
 * `safeNotifyPopupOpener(null, { code, description })` on failure.
 */
export default function safeNotifyPopupOpener(result, error) {
  let fn;
  try {
    fn = window.opener && window.opener.HandlePopupResult;
  } catch {
    return; // COOP-severed proxy — nothing to notify
  }
  if (fn) {
    fn.call(window.opener, result, error);
  }
}
